/* Login Reducer
 * handles login states in the app
 */
import createReducer from '../utils/createReducer';
import * as types from '../actions/types';
import initialState from './initialState';
import { getCountryName } from '../config/country';
import { getLangsFromString } from '../config/language';
import { getUSStateName } from '../config/USStates';

export const rootReducer = createReducer(initialState, {
  [types.CLEAR_CASE](state) {
    return {
      ...state,
      caseType: 'your child',
      caseId: 0,
      patient: {
        firstName: '',
        lastName: '',
        dob: null,
        gender: '',
        story: '',
        dueDate: null,
        addressline1: '',
        addressline2: '',
        city: '',
        state: '',
        country: '',
        zip: '',
        secondaryAddressline1: '',
        secondaryAddressline2: '',
        secondaryCity: '',
        secondaryState: '',
        secondaryCountry: '',
        secondaryZip: '',
        email: '',
        email2: '',
        phone: '',
        phonetype: '',
        phone2: '',
        phone2type: '',
        phone3: '',
        phone3type: '',
        phone4: '',
        phone4type: '',
        languages: [],
        needInterpreter: 'N',
        pcp: '',
        pcpphone: '',
        pcpemail: '',
        cardiologist: '',
        cardiologistphone: '',
        cardiologistemail: '',
        obgyn: '',
        obgynphone: '',
        obgynemail: '',
        pcpletter: false,
        cardiologistletter: false,
        obgynletter: false,
      },
      steponecomplete: false,
      steptwoscreenonecomplete: false,
      steptwoscreentwocomplete: false,
      steptwoscreenthreecomplete: false,
      program: '',
      preferredSurgeon: false,
      preferredSurgeonName: '',
      preferredCardiologist: false,
      preferredCardiologistName: '',
      inpatient: false,
      whyChoose: '',
      hospitalName: '',
      code: '',
      dataUpdated: false,
      viewSummary: true,
      saveBasicInfo: false,
      saveContactInfo: false,
      saveMDInfo: false,
      saveAdditionalInfo: false,
      activeStep: 0,
      createcaseerror: '',
      updatebasicerror: '',
      updatecontacterror: '',
      updatemderror: '',
      updatebcherror: ''
    };
  },
  [types.CLEAR_ERROR](state) {
    return {
      ...state,
      error: '',
      loginerror: '',
      resetpwderror: '',
      resetpwdconfirmerror: '',
      signuperror: '',
      confirmsignuperror: '',
      getCasesError: '',
      resetcodeerror: '',
      createcaseerror: '',
      updatebasicerror: '',
      updatecontacterror: '',
      updatemderror: '',
      updatebcherror: '',
      updatefirstnameerror: '',
      updatelastnameerror: '',
      updateemailerror: '',
      updatephoneerror: '',
      updatepwderror: '',
      checkTerm: false,
      password: '',
      signupActiveStep: 0
    };
  },

  [types.PERSIST_LOGIN](state, action) {
    return {
      ...state,
      email: action.email,
      password: action.password,
      loginerror: ''
    };
  },
  [types.LOGIN_REQUEST](state, action) {
    return {
      ...state,
      email: action.email,
      password: action.password,
      isLoginLoading: true,
      loginerror: ''
    };
  },

  [types.LOGIN_RESPONSE](state, action) {
    return {
      ...state,
      userDetail: action.userDetail,
      isLoggedIn: true,
      isLoginLoading: false,
      //password: '',
      loginerror: ''
      // clear out flags in case UI hangs due to network hung earlier
      // isSignUpLoading: false,
      // isCreateCaseLoading: false,
      // isUpdateCaseLoading: false,
      // isGetCaseLoading: false,
      // isCreateAccountLoading: false,
      // isUpdateAccountFirstNameLoading: false,
      // isUpdateAccountLastNameLoading: false,
      // isUpdateAccountEmailLoading: false,
      // isUpdateAccountPhoneLoading: false,
      // isUpdateAccountPasswordLoading: false
    };
  },
  [types.LOGIN_FAILED](state, action) {
    return {
      ...state,
      isLoggedIn: false,
      isLoginLoading: false,
      loginerror: action.error
    };
  },
  [types.RESET_PASSWORD_REQUEST](state, action) {
    return {
      ...state,
      email: action.email,
      resetpwderror: '',
      isUpdateAccountPasswordLoading: true
    };
  },
  [types.RESET_PASSWORD_RESPONSE](state) {
    return {
      ...state,
      resetpwderror: '',
      isUpdateAccountPasswordLoading: false
    };
  },
  [types.RESET_PASSWORD_FAILED](state, action) {
    return {
      ...state,
      resetpwderror: action.error,
      isUpdateAccountPasswordLoading: false
    };
  },
  [types.RESET_PASSWORD_CONFIRM_REQUEST](state, action) {
    return {
      ...state,
      email: action.email,
      password: action.newPassword,
      resetpwdconfirmerror: '',
      isUpdateAccountPasswordLoading: true
    };
  },
  [types.RESET_PASSWORD_CONFIRM_RESPONSE](state) {
    return {
      ...state,
      resetpwdconfirmerror: '',
      isUpdateAccountPasswordLoading: false
    };
  },
  [types.RESET_PASSWORD_CONFIRM_FAILED](state, action) {
    return {
      ...state,
      resetpwdconfirmerror: action.error,
      isUpdateAccountPasswordLoading: false
    };
  },
  [types.LOG_OUT](state) {
    return {
      ...state,
      isLoginLoading: false,
      isSignUpLoading: false,
      isCreateCaseLoading: false,
      isUpdateCaseLoading: false,
      isGetCaseLoading: false,
      isCreateAccountLoading: false,
      isUpdateAccountFirstNameLoading: false,
      isUpdateAccountLastNameLoading: false,
      isUpdateAccountEmailLoading: false,
      isUpdateAccountPhoneLoading: false,
      isUpdateAccountPasswordLoading: false,
      isLoggedIn: false,
      getCasesError: '',
      error: '',
      loginerror: '',
      resetpwderror: '',
      resetpwdconfirmerror: '',
      signuperror: '',
      confirmsignuperror: '',
      resetcodeerror: '',
      createcaseerror: '',
      updatebasicerror: '',
      updatecontacterror: '',
      updatemderror: '',
      updatebcherror: '',
      updatefirstnameerror: '',
      updatelastnameerror: '',
      updateemailerror: '',
      updatephoneerror: '',
      updatepwderror: '',
      firstName: '',
      lastName: '',
      email: '',
      password: '',
      phone: '',
      caseType: 'your child',
      caseId: 0,
      patient: {
        firstName: '',
        lastName: '',
        dob: null,
        gender: '',
        story: '',
        dueDate: null,
        addressline1: '',
        addressline2: '',
        city: '',
        state: '',
        country: '',
        zip: '',
        secondaryAddressline1: '',
        secondaryAddressline2: '',
        secondaryCity: '',
        secondaryState: '',
        secondaryCountry: '',
        secondaryZip: '',
        email: '',
        email2: '',
        phone: '',
        phonetype: '',
        phone2: '',
        phone2type: '',
        phone3: '',
        phone3type: '',
        phone4: '',
        phone4type: '',
        languages: [],
        needInterpreter: 'N',
        pcp: '',
        pcpphone: '',
        pcpemail: '',
        cardiologist: '',
        cardiologistphone: '',
        cardiologistemail: '',
        obgyn: '',
        obgynphone: '',
        obgynemail: '',
        pcpletter: false,
        cardiologistletter: false,
        obgynletter: false
      },
      steponecomplete: false,
      steptwoscreenonecomplete: false,
      steptwoscreentwocomplete: false,
      steptwoscreenthreecomplete: false,
      program: '',
      preferredSurgeon: false,
      preferredSurgeonName: '',
      preferredCardiologist: false,
      preferredCardiologistName: '',
      inpatient: false,
      whyChoose: '',
      hospitalName: '',
      cases: [],
      contacts: [],
      code: '',
      dataUpdated: false,
      viewSummary: true,
      saveBasicInfo: false,
      saveContactInfo: false,
      saveMDInfo: false,
      saveAdditionalInfo: false,
      showWelcome: true,
      activeStep: 0
    };
  },
  [types.PERSIST_SIGNUP](state, action) {
    return {
      ...state,
      firstName: action.firstName,
      lastName: action.lastName,
      email: action.email,
      password: action.password,
      phone: action.phone,
      signuperror: ''
    };
  },

  [types.CHECK_TERMS_CONDITIONS](state, action) {
    return { ...state, checkTerm: action.checkTerm };
  },
  [types.SIGNUP_REQUEST](state) {
    return {
      ...state,
      isSignUpLoading: true,
      signuperror: ''
    };
  },
  [types.SIGNUP_RESPONSE](state) {
    return {
      ...state,
      isSignUpLoading: false,
      signuperror: ''
    };
  },
  [types.SIGNUP_FAILED](state, action) {
    return {
      ...state,
      isSignUpLoading: false,
      isLoggedIn: false,
      signuperror: action.error
    };
  },
  [types.CONFIRM_SIGNUP_REQUEST](state, action) {
    return {
      ...state,
      email: action.email,
      code: action.code,
      password: action.password,
      phone: action.phone,
      firstName: action.firstName,
      lastName: action.lastName,
      isSignUpLoading: true,
      confirmsignuperror: ''
    };
  },

  [types.CONFIRM_SIGNUP_RESPONSE](state) {
    return {
      ...state,
      isSignUpLoading: false,
      isLoggedIn: true,
      confirmsignuperror: '',
      firstName: '',
      lastName: '',
      phone: ''
      //password: ''
    };
  },

  [types.CONFIRM_SIGNUP_FAILED](state, action) {
    return {
      ...state,
      isSignUpLoading: false,
      isLoggedIn: false,
      confirmsignuperror: action.error
    };
  },

  [types.RESEND_CODE_REQUEST](state, action) {
    return {
      ...state,
      email: action.email,
      resetcodeerror: ''
    };
  },
  [types.RESEND_CODE_RESPONSE](state) {
    return {
      ...state,
      resetcodeerror: ''
    };
  },

  [types.RESEND_CODE_FAILED](state, action) {
    return {
      ...state,
      resetcodeerror: action.error
    };
  },

  [types.GET_PHONE_REQUEST](state) {
    return {
      ...state
    };
  },

  [types.GET_PHONE_FAILED](state) {
    return {
      ...state
    };
  },

  [types.GET_PHONE_RESPONSE](state, action) {
    let { userDetail } = { ...state };
    return {
      ...state,
      userDetail: {
        ...userDetail,
        phone_number: action.phone
      }
    };
  },

  [types.GET_ALL_MY_CASES](state) {
    return {
      ...state,
      caseDetail: null,
      isGetCaseLoading: true,
      getCasesError: ''
    };
  },

  [types.GET_ALL_MY_CASES_RESPONSE](state, action) {
    return {
      ...state,
      cases: action.cases,
      contacts: action.contacts,
      caseDetail: null,
      isGetCaseLoading: false,
      getCasesError: ''
    };
  },
  [types.GET_ALL_MY_CASES_FAIL](state, action) {
    return {
      ...state,
      getCasesError: action.error,
      caseDetail: null,
      isGetCaseLoading: false
    };
  },
  [types.SET_CASE_TYPE](state, action) {
    return {
      ...state,
      caseType: action.caseType
    };
  },
  [types.SET_CASE_ID](state, action) {
    return {
      ...state,
      caseId: action.caseId
    };
  },
  [types.UPDATE_PATIENT_FIRSTNAME](state, action) {
    let { patient } = { ...state };
    return {
      ...state,
      patient: {
        ...patient,
        firstName: action.payload
      }
    };
  },
  [types.UPDATE_PATIENT_LASTNAME](state, action) {
    let { patient } = { ...state };
    return {
      ...state,
      patient: {
        ...patient,
        lastName: action.payload
      }
    };
  },
  [types.UPDATE_PATIENT_DOB](state, action) {
    let { patient } = { ...state };
    return {
      ...state,
      patient: {
        ...patient,
        dob: action.payload
      }
    };
  },
  [types.UPDATE_PATIENT_DUE_DATE](state, action) {
    let { patient } = { ...state };
    return {
      ...state,
      patient: {
        ...patient,
        dueDate: action.payload
      }
    };
  },
  [types.UPDATE_PATIENT_GENDER](state, action) {
    let { patient } = { ...state };
    return {
      ...state,
      patient: {
        ...patient,
        gender: action.payload
      }
    };
  },

  [types.PERSIST_PATIENT_INFO](state, action) {
    let { patient } = { ...state };
    return {
      ...state,
      patient: {
        ...patient,
        firstName: action.firstName,
        lastName: action.lastName,
        dob: action.dob,
        gender: action.gender,
        dueDate: action.dueDate,
        story: action.story
      }
    };
  },

  [types.UPDATE_PATIENT_COUNTRY](state, action) {
    let { patient } = { ...state };
    return {
      ...state,
      patient: {
        ...patient,
        country: action.payload,
        state: ''
      }
    };
  },
  [types.UPDATE_PATIENT_SECONDARY_COUNTRY](state, action) {
    let { patient } = { ...state };
    return {
      ...state,
      patient: {
        ...patient,
        secondaryCountry: action.payload,
        secondaryState: ''
      }
    };
  },

  [types.UPDATE_PATIENT_PHONETYPE](state, action) {
    let { patient } = { ...state };
    return {
      ...state,
      patient: {
        ...patient,
        phonetype: action.payload
      }
    };
  },

  [types.UPDATE_PATIENT_PHONETYPE_2](state, action) {
    let { patient } = { ...state };
    return {
      ...state,
      patient: {
        ...patient,
        phonetype2: action.payload
      }
    };
  },
  [types.UPDATE_PATIENT_PHONETYPE_3](state, action) {
    let { patient } = { ...state };
    return {
      ...state,
      patient: {
        ...patient,
        phonetype3: action.payload
      }
    };
  },
  [types.UPDATE_PATIENT_PHONETYPE_4](state, action) {
    let { patient } = { ...state };
    return {
      ...state,
      patient: {
        ...patient,
        phonetype4: action.payload
      }
    };
  },
  [types.UPDATE_PATIENT_LANGUAGES](state, action) {
    let { patient } = { ...state };
    return {
      ...state,
      patient: {
        ...patient,
        languages: action.payload
      }
    };
  },
  [types.UPDATE_PATIENT_NEEDINTERPRETER](state, action) {
    let { patient } = { ...state };
    return {
      ...state,
      patient: {
        ...patient,
        needInterpreter: action.payload
      }
    };
  },

  [types.UPDATE_PATIENT_PCPLETTER](state, action) {
    let { patient } = { ...state };
    return {
      ...state,
      patient: {
        ...patient,
        pcpletter: action.payload
      }
    };
  },

  [types.UPDATE_PATIENT_CARDIOLOGISTLETTER](state, action) {
    let { patient } = { ...state };
    return {
      ...state,
      patient: {
        ...patient,
        cardiologistletter: action.payload
      }
    };
  },

  [types.PERSIST_PATIENT_CONTACT_INFO](state, action) {
    let { patient } = { ...state };
    return {
      ...state,
      patient: {
        ...patient,
        addressline1: action.addressline1,
        addressline2: action.addressline2,
        city: action.city,
        state: action.state,
        country: action.country,
        zip: action.zip,
        secondaryAddressline1: action.secondaryAddressline1,
        secondaryAddressline2: action.secondaryAddressline2,
        secondaryCity: action.secondaryCity,
        secondaryState: action.secondaryState,
        secondaryCountry: action.secondaryCountry,
        secondaryZip: action.secondaryZip,
        email: action.email,
        email2: action.email2,
        phone: action.phone,
        phone2: action.phone2,
        phone3: action.phone3,
        phone4: action.phone4,
        phonetype: action.phonetype,
        phonetype2: action.phonetype2,
        phonetype3: action.phonetype3,
        phonetype4: action.phonetype4,
        languages: action.languages,
        needInterpreter: action.needInterpreter
      }
    };
  },

  [types.PERSIST_PATIENT_MD_INFO](state, action) {
    let { patient } = { ...state };
    return {
      ...state,
      patient: {
        ...patient,
        pcp: action.pcp,
        pcpphone: action.pcpphone,
        pcpemail: action.pcpemail,
        cardiologist: action.cardiologist,
        cardiologistphone: action.cardiologistphone,
        cardiologistemail: action.cardiologistemail,
        obgyn: action.obgyn,
        obgynphone: action.obgynphone,
        obgynemail: action.obgynemail,
        pcpletter: action.pcpletter,
        cardiologistletter: action.cardiologistletter,
        obgynletter: action.obgynletter
      }
    };
  },
  [types.PERSIST_PATIENT_BCH_INFO](state, action) {
    return {
      ...state,
      program: action.program,
      preferredSurgeon: action.preferredSurgeon,
      preferredSurgeonName: action.preferredSurgeonName,
      preferredCardiologist: action.preferredCardiologist,
      preferredCardiologistName: action.preferredCardiologistName,
      inpatient: action.inpatient,
      whyChoose: action.whyChoose,
      hospitalName: action.hospitalName
    };
  },
  [types.CREATE_CASE_REQUEST](state) {
    return {
      ...state,
      isCreateCaseLoading: true,
      createcaseerror: ''
    };
  },
  [types.CREATE_CASE_RESPONSE](state, action) {
    return {
      ...state,
      caseId: action.response.id,
      returnCode: action.response.statusCode,
      isCreateCaseLoading: false,
      steponecomplete: true,
      createcaseerror: ''
    };
  },
  [types.CREATE_CASE_FAILED](state, action) {
    return {
      ...state,
      isCreateCaseLoading: false,
      steponecomplete: false,
      createcaseerror: action.error
    };
  },
  [types.UPDATE_CASE_BASICINFO_REQUEST](state) {
    return {
      ...state,
      isUpdateCaseLoading: true,
      updatebasicerror: ''
    };
  },
  [types.UPDATE_CASE_BASICINFO_RESPONSE](state, action) {
    return {
      ...state,
      isUpdateCaseLoading: false,
      caseStatus: action.response.caseStatus,
      steponecomplete: action.response.steponecomplete,
      steptwoscreenonecomplete: action.response.steptwoscreenonecomplete,
      steptwoscreentwocomplete: action.response.steptwoscreentwocomplete,
      steptwoscreenthreecomplete: action.response.steptwoscreentwocomplete,
      updatebasicerror: ''
    };
  },
  [types.UPDATE_CASE_BASICINFO_FAILED](state, action) {
    return {
      ...state,
      isUpdateCaseLoading: false,
      updatebasicerror: action.error
    };
  },
  [types.UPDATE_CASE_CONTACTINFO_REQUEST](state) {
    return {
      ...state,
      isUpdateCaseLoading: true,
      updatecontacterror: ''
    };
  },
  [types.UPDATE_CASE_CONTACTINFO_RESPONSE](state) {
    return {
      ...state,
      isUpdateCaseLoading: false,
      steptwoscreenonecomplete: true,
      updatecontacterror: ''
    };
  },
  [types.UPDATE_CASE_CONTACTINFO_FAILED](state, action) {
    return {
      ...state,
      isUpdateCaseLoading: false,
      updatecontacterror: action.error
    };
  },
  [types.UPDATE_CASE_MDINFO_REQUEST](state) {
    return {
      ...state,
      isUpdateCaseLoading: true,
      updatemderror: ''
    };
  },
  [types.UPDATE_CASE_MDINFO_RESPONSE](state) {
    return {
      ...state,
      isUpdateCaseLoading: false,
      steptwoscreentwocomplete: true,
      updatemderror: ''
    };
  },
  [types.UPDATE_CASE_MDINFO_FAILED](state, action) {
    return {
      ...state,
      isUpdateCaseLoading: false,
      updatemderror: action.error
    };
  },
  [types.UPDATE_CASE_BCHINFO_REQUEST](state) {
    return {
      ...state,
      isUpdateCaseLoading: true,
      updatebcherror: ''
    };
  },
  [types.UPDATE_CASE_BCHINFO_RESPONSE](state) {
    return {
      ...state,
      isUpdateCaseLoading: false,
      steptwoscreenthreecomplete: true,
      updatebcherror: ''
    };
  },
  [types.UPDATE_CASE_BCHINFO_FAILED](state, action) {
    return {
      ...state,
      isUpdateCaseLoading: false,
      updatebcherror: action.error
    };
  },

  [types.CREATE_ACCOUNT_REQUEST](state) {
    return {
      ...state,
      isSignUpLoading: true
    };
  },
  [types.CREATE_ACCOUNT_RESPONSE](state) {
    return {
      ...state,
      isSignUpLoading: false
    };
  },
  [types.CREATE_ACCOUNT_FAILED](state, action) {
    return {
      ...state,
      isSignUpLoading: false,
      confirmsignuperror: action.error
    };
  },
  [types.UPDATE_FIRSTNAME_REQUEST](state, action) {
    return {
      ...state,
      firstName: action.firstName,
      isUpdateAccountFirstNameLoading: true,
      updatefirstnameerror: ''
    };
  },
  [types.UPDATE_LASTNAME_REQUEST](state, action) {
    return {
      ...state,
      lastName: action.lastName,
      isUpdateAccountLastNameLoading: true,
      updatelastnameerror: ''
    };
  },
  [types.UPDATE_EMAIL_REQUEST](state, action) {
    return {
      ...state,
      email: action.email,
      isUpdateAccountEmailLoading: true,
      updateemailerror: ''
    };
  },
  [types.UPDATE_PHONE_REQUEST](state, action) {
    let { userDetail } = { ...state };
    return {
      ...state,
      phone: action.phone,
      isUpdateAccountPhoneLoading: true,
      userDetail: {
        ...userDetail,
        phone_number: action.phone
      },
      updatephoneerror: ''
    };
  },
  [types.UPDATE_PASSWORD_REQUEST](state, action) {
    return {
      ...state,
      password: action.password,
      isUpdateAccountPasswordLoading: true,
      updatepwderror: ''
    };
  },
  [types.UPDATE_FIRSTNAME_RESPONSE](state) {
    return {
      ...state,
      updatefirstnameerror: '',
      isUpdateAccountFirstNameLoading: false
    };
  },
  [types.UPDATE_FIRSTNAME_FAILED](state, action) {
    return {
      ...state,
      updatefirstnameerror: action.error,
      isUpdateAccountFirstNameLoading: false
    };
  },
  [types.UPDATE_LASTNAME_RESPONSE](state) {
    return {
      ...state,
      updatelastnameerror: '',
      isUpdateAccountLastNameLoading: false
    };
  },
  [types.UPDATE_LASTNAME_FAILED](state, action) {
    return {
      ...state,
      updatelastnameerror: action.error,
      isUpdateAccountLastNameLoading: false
    };
  },
  [types.UPDATE_EMAIL_RESPONSE](state) {
    return {
      ...state,
      updateemailerror: '',
      isUpdateAccountEmailLoading: false
    };
  },
  [types.UPDATE_EMAIL_FAILED](state, action) {
    return {
      ...state,
      updateemailerror: action.error,
      isUpdateAccountEmailLoading: false
    };
  },
  [types.UPDATE_PHONE_RESPONSE](state) {
    return {
      ...state,
      updatephoneerror: '',
      isUpdateAccountPhoneLoading: false
    };
  },
  [types.UPDATE_PHONE_FAILED](state, action) {
    return {
      ...state,
      updatephoneerror: action.error,
      isUpdateAccountPhoneLoading: false
    };
  },
  [types.UPDATE_PASSWORD_RESPONSE](state) {
    return {
      ...state,
      updatepwderror: '',
      isUpdateAccountPasswordLoading: false
    };
  },
  [types.UPDATE_PASSWORD_FAILED](state, action) {
    return {
      ...state,
      updatepwderror: action.error,
      isUpdateAccountPasswordLoading: false
    };
  },
  [types.GET_CASE_BY_ID_REQUEST](state, action) {
    let { patient } = { ...state };
    return {
      ...state,
      caseType: action.acase.caseType,
      patient: {
        ...patient,
        firstName: action.acase.patientFirstName,
        lastName: action.acase.patientLastName,
        dob: action.acase.patientDob,
        mrn: action.acase.patientMRN,
        gender: action.acase.gender,
        dueDate: action.acase.dueDay,
        story: action.acase.story,
        addressline1: action.acase.addressLine1,
        addressline2: action.acase.addressLine2,
        city: action.acase.city,
        state:
          action.acase.country !== 'US'
            ? action.acase.stateProvince
            : getUSStateName(action.acase.stateProvince),
        country: getCountryName(action.acase.country),
        zip: action.acase.zip,
        secondaryAddressline1: action.acase.secondaryAddressLine1,
        secondaryAddressline2: action.acase.secondaryAddressLine2,
        secondaryCity: action.acase.secondaryCity,
        secondaryState:
          action.acase.secondaryCountry !== 'US'
            ? action.acase.secondaryStateProvince
            : getUSStateName(action.acase.secondaryStateProvince),
        secondaryCountry: getCountryName(action.acase.secondaryCountry),
        secondaryZip: action.acase.secondaryZip,
        email: action.acase.email1,
        email2: action.acase.email2,
        phone: action.acase.phone1,
        phone2: action.acase.phone2,
        phone3: action.acase.phone3,
        phone4: action.acase.phone4,
        phonetype: action.acase.phone1Type,
        phonetype2: action.acase.phone2Type,
        phonetype3: action.acase.phone3Type,
        phonetype4: action.acase.phone4Type,
        languages:
          action.acase.languages !== undefined ? getLangsFromString(action.acase.languages) : [],
        needInterpreter: action.acase.needInterpreter,
        pcp: action.acase.pcp,
        pcpphone: action.acase.pcpPhone,
        pcpemail: action.acase.pcpEmail,
        cardiologist: action.acase.cardiologistName,
        cardiologistphone: action.acase.cardiologistPhone,
        cardiologistemail: action.acase.cardiologistEmail,
        obgyn: action.acase.obgyn,
        obgynphone: action.acase.obgynPhone,
        obgynemail: action.acase.obgynEmail,
        pcpletter:
          action.acase.sendLetter === undefined
            ? false
            : action.acase.sendLetter.includes('Primary Care Physician'),
        cardiologistletter:
          action.acase.sendLetter === undefined
            ? false
            : action.acase.sendLetter.includes('Cardiologist'),
        obgynletter:
          action.acase.sendLetter === undefined
            ? false
            : action.acase.sendLetter.includes('Obstetrician/maternal fetal medicine clinician')
      },
      program: action.acase.program,
      preferredSurgeon:
        action.acase.preferredSurgeonName !== undefined &&
        action.acase.preferredSurgeonName.trim().length !== 0,
      preferredSurgeonName: action.acase.preferredSurgeonName,
      preferredCardiologist:
        action.acase.preferredCardiologistName !== undefined &&
        action.acase.preferredCardiologistName.trim().length !== 0,
      preferredCardiologistName: action.acase.preferredCardiologistName,
      inpatient:
        action.acase.admittedHospital !== undefined && action.acase.admittedHospital !== '',
      whyChoose: action.acase.whyChosen,
      hospitalName: action.acase.admittedHospital === 'Other' ? action.acase.hospitalOtherName : action.acase.admittedHospital
      // isGetCaseByIdLoading: true
    };
  },
  [types.SET_LOCAL_COUNTRYNAME](state, action) {
    return {
      ...state,
      localCountryName: action.localCountryName
    };
  },
  [types.SET_DATA_UPDATED](state, action) {
    return {
      ...state,
      dataUpdated: action.dataUpdated
    };
  },
  [types.SET_VIEW_SUMMARY](state, action) {
    return {
      ...state,
      viewSummary: action.viewSummary
    };
  },
  [types.SET_SAVE_BASICINFO](state, action) {
    return {
      ...state,
      saveBasicInfo: action.saveBasicInfo
    };
  },
  [types.SET_SAVE_CONTACTINFO](state, action) {
    return {
      ...state,
      saveContactInfo: action.saveContactInfo
    };
  },
  [types.SET_SAVE_MDINFO](state, action) {
    return {
      ...state,
      saveMDInfo: action.saveMDInfo
    };
  },
  [types.SET_SAVE_ADDITIONALINFO](state, action) {
    return {
      ...state,
      saveAdditionalInfo: action.saveAdditionalInfo
    };
  },
  [types.SET_ACTIVE_STEP](state, action) {
    return {
      ...state,
      activeStep: action.activeStep
    };
  },
  [types.SET_SIGNUP_ACTIVE_STEP](state, action) {
    return {
      ...state,
      signupActiveStep: action.signupActiveStep
    };
  },

  [types.ACCESS_CASE_REQUEST](state) {
    return {
      ...state,
      isAccessCaseLoading: true,
      createcaseerror: ''
    };
  },
  [types.ACCESS_CASE_RESPONSE](state, action) {
    return {
      ...state,
      returnCode: action.response.statusCode,
      isAccessCaseLoading: false,
      createcaseerror: ''
    };
  },
  [types.ACCESS_CASE_FAILED](state, action) {
    return {
      ...state,
      isAccessCaseLoading: false,
      createcaseerror: action.error
    };
  },
  [types.SET_SHOW_WELCOME](state, action) {
    return {
      ...state,
      showWelcome: action.showWelcome
    };
  }
});

export default rootReducer;
